import "./InputText.scss";
import Button from "core/buttons/button/Button";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

const InputTextComment = ({
  value,
  setCommentOpened,
  commentOpened,
  left,
  id,
  settings,
  onClick,
  readOnly,
  getValue,
}) => {
  const intl = useIntl();
  const [comment, setComment] = useState(value);
  const commentModalRef = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        commentOpened &&
        commentModalRef.current &&
        !commentModalRef.current.contains(e.target)
      ) {
        setCommentOpened(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [commentOpened]);

  return (
    <div
      className="input-text-commentary"
      style={{ marginLeft: `${left / 10}px`, zIndex: "5" }}
      id={id}
      ref={commentModalRef}
    >
      <div className="input-text-commentary-title">
        <FormattedMessage {...settings.title} />
      </div>
      <div
        className="input-text-commentary-close"
        onClick={() => onClick(false)}
        id={`close-button-${id}`}
      ></div>
      <div className="input-text-commentary-content">
        <textarea
          className="input-text-commentary-content-textarea"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={intl.formatMessage(settings.placeholder)}
          disabled={readOnly}
          id={`text-area-${id}`}
        />
      </div>
      {!readOnly && (
        <div className="input-text-commentary-buttons">
          <Button
            color="btn-standard gray-700"
            onClick={(e) => {
              e.preventDefault();
              getValue(comment);
              onClick(false);
            }}
            id={`sumbit-buttom-${id}`}
          >
            <FormattedMessage {...settings.button_value} />
          </Button>
        </div>
      )}
    </div>
  );
};

InputTextComment.propTypes = {
  value: PropTypes.string,
  setCommentOpened: PropTypes.func.isRequired,
  commentOpened: PropTypes.bool.isRequired,
  left: PropTypes.number,
  id: PropTypes.string,
  settings: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  getValue: PropTypes.func.isRequired,
};

InputTextComment.defaultProps = {
  value: "",
  left: null,
  id: "",
  settings: {},
  readOnly: false,
};

export default InputTextComment;
